import type { ChangelogData } from "./changelogTypes";

export const changelog: ChangelogData = {
  versions: [
    {
      version: "40.0.0",
      date: "2026-08-07",
      entries: [
        {
          id: "3ff258f6",
          category: "improvement",
          title: "War Room destination mode on the toggle",
          description:
            "The War Room toggle label now shows which destination mode is active so you can see the current setting at a glance.",
        },
        {
          id: "07edd7da",
          category: "fix",
          title: "Timeline sort stays put when using tick tooltips",
          description:
            "Sorting people on the timeline no longer jumps back after you use the header tick tooltips.",
        },
        {
          id: "f5758b04",
          category: "improvement",
          title: "Clearer custom domain removal confirmations",
          description:
            "Removing a custom domain now shows clearer confirmation wording so you know what will happen before you confirm.",
        },
        {
          id: "0b3fee4d",
          category: "fix",
          title: "Duplicate task events shared for the whole board",
          description:
            "The setting that hides overlapping duplicate task events is now board-wide, so one person’s preference no longer hides events for everyone else.",
        },
        {
          id: "6c958dab",
          category: "fix",
          title: "Template boards show in Recently Viewed",
          description:
            "Boards you create from a template now appear in Recently Viewed on My Swivu.",
        },
        {
          id: "bca41e7d",
          category: "improvement",
          title: "Company Cam key on the board",
          description:
            "Connect Company Cam with a board preference key (same idea as OpenAI), then link projects without keeping a key only in the browser.",
        },
        {
          id: "d09c377b",
          category: "improvement",
          title: "Test Drive Site publishing locked",
          description:
            "On Test Drive boards, Site and page publish controls stay visible but disabled so you can’t publish from a sandbox board.",
        },
        {
          id: "65ae0f8f",
          category: "feature",
          title: "Clock attendance review",
          description:
            "Managers can open Clock to review attendance by person and day, handle exceptions, and clear open items in bulk.",
        },
        {
          id: "300f67ec",
          category: "fix",
          title: "More reliable file and photo previews",
          description:
            "Image and file previews load more reliably from secure links, including on the Users surface.",
        },
        {
          id: "912df0d4",
          category: "feature",
          title: "Redesigned Users view",
          description:
            "Users now opens as a sidebar list with a detail pane for overview, tasks, ownership, points, and content, plus performance glances.",
        },
        {
          id: "7283fb49",
          category: "feature",
          title: "Company Cam photos on the linked record",
          description:
            "When you link a Company Cam project, its photos and documents show up in that record’s Media and Documents.",
        },
        {
          id: "9306aca4",
          category: "fix",
          title: "Recently Viewed updates when you open a board",
          description:
            "Opening a board from create or a direct link now updates Recently Viewed right away.",
        },
        {
          id: "1ffeaa63",
          category: "feature",
          title: "Site DNS setup and publish preview",
          description:
            "Set up custom domain DNS in a dedicated modal, and use Publish preview with clearer wording for what you’re about to share.",
        },
        {
          id: "ad371cab",
          category: "feature",
          title: "Word and PDF from Work Files",
          description:
            "Generate Word and PDF marketing documents from Work Files and keep them listed with your other marketing outputs.",
        },
      ],
    },
  ],
};
